import React from 'react';
import './About.css';

const MARKET_STATS = [
  { label: 'Transportistas verificados', value: '350+' },
  { label: 'Cargas publicadas', value: '15,000+' },
  { label: 'Match rate', value: '98%' },
];

const HERO_VISUAL_CARDS = [
  { id: 'match', label: 'Match', value: 'Carga ↔ Unidad', meta: 'Tiempo real', style: { top: '5%', left: '8%' } },
  { id: 'route', label: 'Ruta activa', value: 'CDMX → MTY', meta: '16 h estimadas', style: { top: '55%', left: '0%' } },
  { id: 'success', label: 'Success', value: 'Operación segura', meta: 'Seguro + tracking', style: { top: '32%', right: '4%' } },
];

const HERO_NODES = [
  { id: 'cdmx', label: 'CDMX', style: { top: '18%', left: '22%' } },
  { id: 'gdl', label: 'GDL', style: { top: '42%', left: '15%' } },
  { id: 'mty', label: 'MTY', style: { top: '30%', right: '18%' } },
  { id: 'bog', label: 'BOG', style: { bottom: '18%', left: '32%' } },
  { id: 'scl', label: 'SCL', style: { bottom: '12%', right: '22%' } },
];

const VALUE_COLUMNS = [
  {
    type: 'clients',
    title: 'Para Clientes',
    description: 'Encuentra transporte seguro en minutos. Publica tu carga y recibe ofertas verificadas.',
    bullets: ['Visibilidad completa del viaje.', 'Operadores evaluados por desempeño y cumplimiento.'],
    icon: 'box',
  },
  {
    type: 'carriers',
    title: 'Para Transportistas',
    description: 'Mantén tus camiones llenos. Accede a miles de cargas y cobra rápido.',
    bullets: ['Pagos ágiles y soporte operativo.', 'Optimiza rutas con datos en tiempo real.'],
    icon: 'truck',
  },
];

const TRUST_BADGES = [
  { title: 'SAT Validated', description: 'Validamos RFC y obligaciones fiscales.' },
  { title: 'Identity Check', description: 'Verificación biométrica y documental.' },
  { title: 'Insurance', description: 'Coberturas activas y certificados vigentes.' },
];

const VALUE_ICONS = {
  box: (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M6 16 24 6l18 10v16L24 42 6 32Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M24 42V24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="m6 16 18 10 18-10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  ),
  truck: (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <path
        d="M4 30V14h22v16m0-10h10l6 6v8h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14" cy="34" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
      <circle cx="34" cy="34" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
    </svg>
  ),
};

export default function About() {
  return (
    <main className="about-modern">
      <section className="about-hero about-hero--network">
        <div className="about-hero__grid">
          <div className="about-hero__content">
            <p className="about-kicker">Marketplace logístico</p>
            <h1 className="about-hero__title">
              La red logística más grande de <span className="about-hero__highlight">LatAm</span>
            </h1>
            <p className="about-hero__subtitle">
              Conectamos a quienes tienen carga con quienes tienen camiones. Sin intermediarios y sin fricción, solo
              operaciones confirmadas que se activan en minutos para toda la región.
            </p>
          </div>
          <div className="about-hero__visual" aria-hidden="true">
            <div className="about-hero-visual__glow" />
            <div className="about-hero-visual__network">
              {HERO_NODES.map(node => (
                <span key={node.id} className="about-hero-node" style={node.style}>
                  {node.label}
                </span>
              ))}
            </div>
            {HERO_VISUAL_CARDS.map(card => (
              <article key={card.id} className="about-hero-card" style={card.style}>
                <span className="about-hero-card__label">{card.label}</span>
                <strong className="about-hero-card__value">{card.value}</strong>
                <p className="about-hero-card__meta">{card.meta}</p>
              </article>
            ))}
          </div>
        </div>
        <div className="about-hero__stats">
          {MARKET_STATS.map(stat => (
            <div key={stat.label} className="about-hero__stat">
              <span className="about-hero__stat-value">{stat.value}</span>
              <span className="about-hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="about-value">
        {VALUE_COLUMNS.map(column => (
          <article key={column.type} className={`value-card value-card--${column.type}`}>
            <div className="value-card__icon">{VALUE_ICONS[column.icon]}</div>
            <div>
              <p className="about-kicker">{column.title}</p>
              <h2>{column.description}</h2>
              <ul>
                {column.bullets.map(bullet => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </section>

      <section className="about-trust">
        <div className="about-trust__copy">
          <p className="about-kicker">Confianza</p>
          <h2>Todos nuestros usuarios pasan por una verificación rigurosa.</h2>
          <p>Compliance continuo con señales fiscales, identidad y pólizas actualizadas.</p>
        </div>
        <div className="about-trust__grid">
          {TRUST_BADGES.map(badge => (
            <article key={badge.title}>
              <span />
              <strong>{badge.title}</strong>
              <p>{badge.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-team about-team--simple">
        <div className="about-team__text">
          <p className="about-kicker">Equipo</p>
          <h2>Construido por expertos en logística y tecnología</h2>
          <p>
            Operamos desde los principales hubs de LatAm junto a especialistas en transporte, producto y data.
            Nuestro equipo entiende las rutas, las temporadas altas y las urgencias del día a día.
          </p>
        </div>
        <div className="about-team__photo">
          <img src="/Images/Transportistas.png" alt="Equipo de Flotte colaborando" loading="lazy" />
        </div>
      </section>
    </main>
  );
}
